import React, { ReactElement, useState } from 'react';
import { ReactComponent as CurrencyImg } from '../../assets/images/svg/rupee_symbol.svg';
import { ReactComponent as AyushmanBharathImg } from '../../assets/images/svg/Ayushman_Bharath_logo.svg';
import { Button, Card, Col, Form, Input, Row } from 'antd';
import { GUTTOR_SPACE, VALIDATE_MESSAGES } from '../../shared/constants/commonConstants';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { refreshInternalData } from '../../store/actions/utilAction';
import { ApplicationDetailModel } from '../../store/models/applicationDetailModel';
import { RootState } from '../../store';
import { applyFilters, registerForHIU } from '../../store/actions/abdmHiuAction';
import { applyLinkedRecordsFilters } from '../../store/actions/linkContextAction';

const AbdmHome = ({ match, location }: any): ReactElement | null => {
  const [abdmHiuForm] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const [facilityId, setFacilityId] = useState<string>('');
  const appDetail = useSelector((state: RootState): ApplicationDetailModel => state?.applicationDetail);
  const hipId = appDetail?.getHipId() !== ('null' || undefined || null);

  const onRegistrationSuccess = (): any => {
    setIsLoading(false);
    dispatch(refreshInternalData(true, false, false, false, false));
  };

  const onRegistrationError = (): any => {
    setIsLoading(false);
  };

  const onFetchRecords = (): any => {
    dispatch(applyFilters({ abhaAddress: '' }));
    history.push('/abdm/concent-list');
  };

  const onFetchLinkedRecords = (): any => {
    dispatch(applyLinkedRecordsFilters({ searchFilter: '' }));
    history.push('/abdm/records-list');
  };

  const registerAsHIPHiu = (): any => {
    abdmHiuForm.validateFields().then((): any => {
      setIsLoading(true);
      dispatch(registerForHIU(onRegistrationSuccess, onRegistrationError, facilityId));
    });
  };

  return <div className="abhacontent">
    <Row gutter={GUTTOR_SPACE}>
    <Col md ={12} className ="abhadiv">
      <Card className="abhaCard">
        <div className="abhaImg">
      <div><AyushmanBharathImg /></div>
      </div>
      <p>Avail the advantages offered by the</p>
      <div className="largeText">
        DIGITAL <br/>
        HEALTH  <br/>
        INCENTIVE
        SCHEME  (DHIS)

      </div>
      <div className = "rupeesImg">
        <CurrencyImg/>
        </div>
      <div className= "cardBottomDiv">
        <p>Earn upto INR 4 crores* of Incentives</p>
      </div>
    </Card>
    <div className="bottomDiv">
    <div>*Terms & Conditions Apply</div>
    </div>
    </Col>
   <Col md ={12}>
    <Card className="cardForm">
      <div className="headingDiv">
        Health Repository Provider
      </div>
      <Form
        form={abdmHiuForm}
        validateMessages={VALIDATE_MESSAGES}
      >
        {!hipId &&
          <React.Fragment>
            <Row gutter={GUTTOR_SPACE}>
              <Col md={24}>
                <Form.Item name="facilityId" rules={[{ required: true, message: 'Facility Id is required!' }]}>
                  <Input placeholder="Enter Facility ID" onChange={(e: any): any => setFacilityId(e?.target?.value || '')} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={GUTTOR_SPACE} className="mt-btn">
              <Col md={24}>
                <Button
                  loading={isLoading}
                  type="primary"
                  className="w-100 abhaFormButtons"
                  onClick={registerAsHIPHiu}>
                  Register as HIP/ HIU
                </Button>
              </Col>
            </Row>
          </React.Fragment>
        }
        {
          hipId && <Row gutter={GUTTOR_SPACE} className="mt-sm">
            <Col md={24}>
              <Button
                type="primary"
                className="w-100 abhaFormButtons"
                onClick={onFetchLinkedRecords}>Link Records</Button>
            </Col>
            <Col md={24} className="mt-sm">
              <Button
                type="primary"
                className="w-100 abhaFormButtons"
                onClick={onFetchRecords}>Fetch Records</Button>
            </Col>
          </Row>
        }
      </Form>
    </Card>
    </Col>
    </Row>
  </div>;
};

export default AbdmHome;
